/**
 * Status codes observed in the WFH history contract / backend tests.
 * Write-flow statuses may appear later when apply/cancel become safe.
 */
const LABELS: Record<string, string> = {
  APPROVED: 'Approved',
  CANCELLED: 'Canceled',
  CANCELED: 'Canceled',
  PENDING: 'Pending approval',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  WITHDRAWN: 'Withdrawn',
  DRAFT: 'Draft',
};

const MESSAGES: Record<string, string> = {
  APPROVED: 'This WFH request was approved.',
  CANCELLED: 'This WFH request was canceled.',
  CANCELED: 'This WFH request was canceled.',
  PENDING: 'This WFH request is waiting for approval.',
  SUBMITTED: 'This WFH request was submitted.',
  REJECTED: 'This WFH request was rejected.',
  WITHDRAWN: 'This WFH request was withdrawn.',
  DRAFT: 'This WFH request is still a draft.',
};

const CATEGORIES: Record<
  string,
  'neutral' | 'success' | 'warning' | 'danger' | 'info'
> = {
  APPROVED: 'success',
  CANCELLED: 'neutral',
  CANCELED: 'neutral',
  PENDING: 'warning',
  SUBMITTED: 'info',
  REJECTED: 'danger',
  WITHDRAWN: 'neutral',
  DRAFT: 'neutral',
};

export function getWfhStatusLabel(status: string | null | undefined): string {
  if (!status) return 'Status unavailable';
  return LABELS[status] ?? 'Status unavailable';
}

export function getWfhStatusMessage(status: string | null | undefined): string {
  if (!status) return 'WFH status is unavailable.';
  return MESSAGES[status] ?? 'WFH status is unavailable.';
}

export function getWfhStatusCategory(
  status: string | null | undefined,
): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  if (!status) return 'neutral';
  return CATEGORIES[status] ?? 'neutral';
}
